import { __awaiter } from 'tslib';
import { useState } from 'react';
import '../../services/base/baseDiscoverService.js';
import '../../services/base/baseV3Service.js';
import '../../services/sgtService.js';
import '@analytics/storage-utils';
import 'date-fns/format';
import 'date-fns/secondsToMinutes';
import 'date-fns/isValid';
import 'date-fns/addMinutes';
import 'date-fns';
import 'date-fns-tz';
import '../../utils/ErrorProvider.js';
import '../../utils/LoaderProvider.js';
import '../../utils/RefetchProvider.js';
import '../../utils/NotificationProvider.js';
import '../../utils/ContactProvider.js';
import '../../utils/PolicyProvider.js';
import { useAnalytics } from '../../utils/AnalyticsProvider.js';
import '../../types/AccessDevice.js';
import '../../types/Analytics.js';
import '../../types/CASACommunity.js';
import '../../types/Community.js';
import '../../types/DxSettings.js';
import '../../types/MagicButton.js';
import '../../types/Pannellum.js';
import '../../types/Prospect.js';
import '../../types/ProspectIntelligence.js';
import '../../types/Space.js';
import '../../types/Tour.js';
import '../../utils/analyticsPlugin.js';
import '../../utils/communityGoogleAnalyticsPlugin.js';
import 'qs';
import '../../utils/cookieUtils.js';
import '../../utils/termsConditionsAgreementsUtils.js';
import '../../services/base/analyticsV2BaseService.js';
import { createProspect } from '../../services/prospectService.js';
import 'axios';
import '../../services/base/internalApiBaseService.js';
import '../../services/base/casaBaseService.js';
import '../../services/scanRequestsService.js';
import '../../services/db/insightsReportsDB.js';

const useCreateProspect = () => {
    const [prospect, setProspect] = useState(null);
    const [error, setError] = useState(null);
    const [loading, setLoading] = useState(false);
    const analytics = useAnalytics();
    const api = (prospectPayload) => __awaiter(void 0, void 0, void 0, function* () {
        let res;
        try {
            setLoading(true);
            setProspect(null);
            setError(null);
            res = (yield createProspect(prospectPayload));
            analytics === null || analytics === void 0 ? void 0 : analytics.identify(res.prospectId, {
                prospectEmail: prospectPayload.email,
                prospectCommunity: prospectPayload.communityId,
            });
            setProspect(res);
        }
        catch (error) {
            setError(error);
        }
        finally {
            setLoading(false);
            return res;
        }
    });
    return [api, prospect, loading, error];
};

export { useCreateProspect };
